import { render, staticRenderFns } from "./Capsule.vue?vue&type=template&id=90af7c38&scoped=true&"
import script from "./Capsule.vue?vue&type=script&lang=js&"
export * from "./Capsule.vue?vue&type=script&lang=js&"
import style0 from "./Capsule.vue?vue&type=style&index=0&id=90af7c38&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90af7c38",
  null
  
)

export default component.exports